interface DefaultTo {
  <T, U>(defaultValue: T): {
    (value?: U): T;
  };
  <T, U>(defaultValue: T): {
    (value: U): U;
  };
}

const defaultTo: DefaultTo = <T, U>(defaultValue: T) => (value: U) =>
  (value === null || value === undefined) ? defaultValue : value;

export default defaultTo;
